/* eslint-disable security/detect-object-injection */
import { get } from "lodash";
import { getLowestNonZeroWholesale } from "areas/verifications/helpers/util";
import { normalizePrice } from "shared/listing-helpers";

import { calculatePriceMargin } from "./index";

export function formatShopifyConnectionResource(productData, normalizedSizesDictionary, retailerMargin) {
  const { margin, ignore_shopify_cpi } = retailerMargin;

  let isAllStandardSizes = true;
  const matchingColorsByImageId = {};
  const sizes = productData.size_variants?.map(s => {
    const { size, image_id, id, inventory_quantity, barcode } = s;
    const normalized = normalizedSizesDictionary[size];
    if (isAllStandardSizes && !normalized) {
      isAllStandardSizes = false;
    }

    // set up ability to highlight correct color image
    if (productData.color) {
      if (!matchingColorsByImageId[image_id]) {
        matchingColorsByImageId[image_id] = new Set();
      }
      matchingColorsByImageId[image_id].add(productData.color);
    }
    return {
      id,
      size,
      quantity: inventory_quantity,
      barcode: barcode || "",
      normalized: normalized || "-"
    };
  });

  const imagesToHighlight = productData.product.images
    .map(image => {
      const matchingColors = matchingColorsByImageId[image.id];
      if (matchingColors) {
        return { ...image, color: [...matchingColors] };
      }
      // eslint-disable-next-line unicorn/no-null
      return null;
    })
    .filter(Boolean);

  const lowestNonZero = getLowestNonZeroWholesale((productData.size_variants || []).map(sv => sv.wholesale_cost));
  const incomingWholesale = normalizePrice(lowestNonZero);
  const retail =
    Number(Number(productData.size_variants?.[0]?.compare_at_price)) ||
    Number(Number(productData.size_variants?.[0]?.price)) ||
    0;
  const { isWholesaleCalculatedFromMargin, wholesale } = calculatePriceMargin({
    wholesale: incomingWholesale,
    margin,
    ignoreShopifyRetailer: ignore_shopify_cpi,
    retail
  });

  return {
    title: productData.product.title,
    color: productData.color,
    incomingBrand: productData.product.vendor,
    brand:
      (productData?.data?.brand && `${productData?.data?.brand}`) || (productData?.brand && `${productData.brand}`),
    retailerDescription: productData.product.body_html,
    sizes,
    sku: get(productData, "sku", get(productData, "size_variants.0.sku", "")),
    wholesale,
    images: productData.product.images.map(image => image?.src).filter(Boolean),
    incomingPrices: {
      wholesale: incomingWholesale,
      retail,
      compareAtPrice: productData.size_variants?.[0]?.compare_at_price
    },
    hasWholesale: wholesale > 0,
    isAllStandardSizes,
    imagesToHighlight,
    isWholesaleCalculatedFromMargin
  };
}
